const isBankActive = (bankDetails) =>
  bankDetails &&
  bankDetails.bankDetailsUuid &&
  (bankDetails.status === 0 || bankDetails.status === 1);
export default isBankActive;
